import gql from 'graphql-tag';

import { contentAppearancePublishedFragment } from '@confluence/content-appearance/entry-points/fragments';

// If provided the content ID, the backend will evaluate the share token against it to verify the reference.
// It will return a 404 if the content ID does not match the share token.
export const SharedContentQuery = gql`
	query SharedContentQuery($shareToken: String!, $contentId: ID, $includeAlias: Boolean = false) {
		singleContent(shareToken: $shareToken, id: $contentId) {
			id
			referenceId
			space {
				id
				key
				alias @include(if: $includeAlias)
				name
			}
			title
			type
			status
			history {
				createdDate
				lastUpdated {
					when
				}
			}
			...contentAppearancePublishedFragment
			properties(key: "editor") {
				nodes {
					id
					key
					value
				}
			}
		}
	}

	${contentAppearancePublishedFragment}
`;
